export default [
  {
    path: '/integration',
    name: 'integration',
    component: () => import('@/views/integration/View.vue'),
    meta: {
      pageTitle: 'breadcrumb.integration',
      navActiveLink: 'integration',
      resource: 'merchant-integration',
      action: 'read',
      breadcrumb: [
        {
          text: 'breadcrumb.integration',
          active: true,
        },
      ],
    },
  },
]
